import React, { useEffect, useState } from 'react';
import VersionHistory from 'src/components/common/VersionHistory';
import { usePermissionWrapper } from 'src/components/hooks/usePermissionWrapper';
import { archLevel } from 'src/data/config';
import { useAppSelector } from 'src/store';
import { setMessage } from 'src/store/Message';
import { useAppDispatch } from 'src/store/hooks';
import InterimMonitoringVisitConfirmationLetter from './InterimMonitoringVisitConfirmationLetter';
import { DataTable } from '@pihealth/common-ui-library';
import staticData from '../../../../resources/static.json';
import { usePreferedDateFormat } from 'src/util/DateFormatter';
import { GridToolbarExport } from '@mui/x-data-grid-pro';
import moment from 'moment';
const DataGridConfirmationLetter: React.FunctionComponent<any> = (props: any) => {
  const { userPreferedDateFormat } = usePreferedDateFormat();
  const [showVersionHistory, setShowVersionHistory] = useState(false);
  const [headerTitle, setHedertitle] = useState('');
  const [docId, setDocId] = useState('');
  const isHierarchyLevelClosed: boolean = useAppSelector(state => state.site.isHierarchyLevelClosed);
  const studyId: any = useAppSelector(state => state.site.selectedStudy);
  const selectedCountry = useAppSelector(state => state.site.selectedCountry);
  const selectedSite = useAppSelector(state => state.site.selectedSite);
  const dispatch = useAppDispatch();
  const { checkPermission } = usePermissionWrapper();
  const [visitData, setVisitData] = useState({});
  useEffect(() => {
    props.setOpenLetter(false);
  }, [isHierarchyLevelClosed, studyId, selectedCountry, selectedSite]);
  const handleChange = async (rowData: any) => {
    if (archLevel === 'site') {
      if (rowData?.major_version >= '1.0') {
        setVisitData(rowData);
        props.setOpenLetter(true);
      } else {
        dispatch(setMessage({ msgDetails: `${rowData?.visit_name} not yet Published`, severity: 'error' }));
      }
    } else if (selectedSite && checkPermission('view_published_imvconfletter')) {
      setVisitData(rowData);
      props.setOpenLetter(true);
    } else if (!selectedSite) {
      dispatch(
        setMessage({
          msgDetails: 'Please select the site',
          severity: 'error'
        })
      );
    }
  };
  const handleVersionHistory = async (selectedRow: any) => {
    setHedertitle(selectedRow.visit_name);
    setDocId(selectedRow?.tp_document_id);
    setShowVersionHistory(true);
  };
  const actions = {
    visit_name: (data: any) => {
      handleChange(data);
    },
    major_version: (data: any) => {
      handleVersionHistory(data);
    }
  };
  const definedCustomDatGridExport = (exportFields: any = {}) => {
    return (
      <GridToolbarExport
        csvOptions={{
          fileName: `${`Conduct Interim Monitoring Visit Confirmation`} ${moment(new Date()).format(
            `${(userPreferedDateFormat.includes('/')
              ? userPreferedDateFormat.replaceAll('/', '_')
              : userPreferedDateFormat.replaceAll('-', '_')
            ).toUpperCase()} hh_mm A`
          )}`
        }}
      />
    );
  };
  return (
    <div>
      {props.openLetter ? (
        <InterimMonitoringVisitConfirmationLetter
          visitData={visitData}
          SiteStudyData={props.result}
          setOpenLetter={props.setOpenLetter}
          setIsChanged={props.setIsChanged}
          isChanged={props.isChanged}
        />
      ) : (
        <DataTable
          columns={staticData.imvChecklist.columns}
          rows={props.rows}
          loading={props.isLoading}
          actions={actions}
          datePreference={userPreferedDateFormat}
          className="studylogDatagrid"
          exportAll
          height="74vh"
          hasDefinedDataGridToolbarExport
          definedGridToolbarExport={definedCustomDatGridExport}
        />
      )}
      {showVersionHistory && (
        <VersionHistory
          openVersoinHistory={showVersionHistory}
          setOpenVersoinHistory={setShowVersionHistory}
          title={headerTitle}
          documentId={docId}
          auditModuleSection={'IMV CONFIRMATION'}
        />
      )}
    </div>
  );
};
export default DataGridConfirmationLetter;
